import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {parse, printTree, tokenizing} from './expression-parser';
import {DeviceparamModel} from '../../../../api/src/deviceparam/deviceparam.model';
import {CalcparamModel} from '../../../../api/src/calcparam/calcparam.model';


@Component({
    selector: 'app-form-expression-viewer',
    templateUrl: './form-expression-viewer.component.html',
    styleUrls: ['./form-expression-viewer.component.scss'],
    standalone: false
})
export class FormExpressionViewerComponent implements OnInit, OnChanges {

  @Input() expression = '';
  @Input() deviceparams: DeviceparamModel[] = [];
  @Input() calcparams: CalcparamModel[] = [];
  @Input() paramsLabels: {label: string; id: number}[];
  @Input() showResolveButton = false;
  @Output() resolveParamNames = new EventEmitter<string[]>();
  public formatedExpression = '';

  public ast = [];

  constructor() {
  }

  ngOnInit() {
    return;
  }


  ngOnChanges(changes) {
    const expression =changes.expression ? changes.expression.currentValue : this.expression;
    const tokens = tokenizing(expression);
    if (expression) {
      this.ast = parse(tokens.length > 0 ? tokens : [{type: 'param', value: expression}]);
    } else {
      this.ast = [];
    }
    try {
      this.decodeParams(this.ast);
    } catch (e) {
    }
    this.formatedExpression = printTree(this.ast);

  }

  findParamName(name) {

    if (name.substr(0, 1) === 'L') {
      return (this.paramsLabels.find(_param => +_param.id === +name.substr(1)) || {}).label;
    }

    if (name.substr(0, 1) === 'P') {
      return (this.paramsLabels.find(_param => +_param.id === +name.substr(1)) || {}).label;
    }

    if (name.substr(0, 1) === 'C') {
      return (this.calcparams.find(_param => +_param.id === +name.substr(1)) || {}).paramname;
    }

    if (name.substr(0, 1) === 'D') {
      return (this.deviceparams.find(_param => +_param.id === +name.substr(1)) || {}).paramname;
    }

    return undefined;
  }

  public resolveNames(): void {
    const result = this.findParams();
    this.resolveParamNames.next(result);
  }

  public findParams(): string[] {
    const tokens = tokenizing(this.expression);

    const ast = parse(tokens.length > 0 ? tokens : [{type: 'param', value: this.expression}]);
    const result: string[] = [];
    ast.forEach(node => {
      if (node.type === 'param') {
        result.push(node.value);
      }
    });
    return result;
  }

  decodeParams(nodes): void {

    nodes.forEach(_node => {
      if (_node.type === 'block') {
        this.decodeParams(_node.items);
      }

      if (_node.type === 'param') {
        _node.value = this.findParamName(_node.value) || _node.value;
      }
    });
  }
}
